module.exports = __webpack_public_path__ + "img/confirmation-tests-inactive.25af46b2.svg";